import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import Form, { FormInput } from '../common/Form';
import Pager from '../common/Pager';
import useApiGet from '../../hooks/useApiGet';
import useApiList from '../../hooks/useApiList';
import getLogo from '../../utils/getLogo';
import { PAGE_LIMIT } from '../../config';

const ExhibitorList = () => {
	const limit = PAGE_LIMIT;
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
	const auth = useSelector(state => state.auth.user);
	const [ find, setFind ] = useState('');
	const [ skip, setSkip ] = useState(0);
	const [ event, setEvent ] = useState('');
	// eslint-disable-next-line
	const [ admin, setAdmin ] = useState(auth?.role === 'admin' ? auth?._id : null);
	// eslint-disable-next-line
	const [ method, setMethod ] = useState(auth?.role === 'admin' ? '/exhibitorsbyadmin' : '/exhibitors');
	// eslint-disable-next-line
	const [ params, setParams ] = useState({ method: auth?.role === 'admin' ? '/eventsbyadmin' : '/events', params: { admin }});
	// eslint-disable-next-line
	const [ events, eventsError, isEventsLoading ] = useApiGet(params);
	const [ data, error, isLoading ] = useApiList({ method, limit, find, skip, event, admin });
	const [ eventsOptions, setEventsOptions ] = useState([]);

	useEffect(() => {
		if(!events) return;
		let options = [];
		events.events.forEach(e => options.push({ text: e.name[lang], value: e._id }));
		options.sort((a, b) => a.text.localeCompare(b.text));
		setEventsOptions(options);
	}, [ events, lang ]);

	useEffect(() => {
		setSkip(0);
	}, [ find, event ]);

	return (
		<div>
	    	<h1>{t('exhibitorlist.title')}</h1>
			<Form error={error}>
				<FormInput
					id='find'
					type='text'
					value={find}
					placeholder={t('exhibitorlist.placeholder')}
					onChange={setFind}
				/>
				{eventsOptions.length > 0 &&
				<FormInput
					id='event'
					type='select'
					value={event}
					onChange={setEvent}
					hint={t('useradd.event_hint')}
					list={eventsOptions}
				/>}
			</Form>

			{isLoading ? <span>{t('common.loading')}</span> :
			<React.Fragment>
				{data &&
				<React.Fragment>
					<div>
						{data.total ? t('exhibitorlist.found') + data.total : t('exhibitorlist.notfound')}
					</div>
					<div className='list'>
					{data.exhibitors.map(exhibitor => (
						<div
							key={exhibitor._id}
							className='item'
							onClick={() => navigate('/cabinet/exhibitorview/' + exhibitor._id)}
						>
							<img alt='icon' className='icon' src={getLogo(exhibitor)}/>
							<div className='text'>
								{exhibitor.name[lang]}<br/>
								<small>{exhibitor.event.name[lang]}</small>
							</div>
						</div>
					))}
					</div>
					<Pager total={data.total} skip={skip} limit={limit} setSkip={setSkip}/>
				</React.Fragment>}
			</React.Fragment>}
		</div>
	);
};

export default ExhibitorList;
